import "./cameraEditor.1acb9652.js";
import "./cameraEditor.ac8d2df4.js";
import "./cameraEditor.737f6996.js";
import "./dhLinks.29e4c113.js";
import "./ik.7dba1b73.js";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1149"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1149"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $jw0R5 = parcelRequire("jw0R5");

var $2sw9m = parcelRequire("2sw9m");

var $lsYJx = parcelRequire("lsYJx");

var $ctZJO = parcelRequire("ctZJO");

var $6BOAB = parcelRequire("6BOAB");

var $bPqRC = parcelRequire("bPqRC");

var $bMVXx = parcelRequire("bMVXx");

var $2hZdK = parcelRequire("2hZdK");

var $kjkPx = parcelRequire("kjkPx");
// Convert standard-DH joint variables to the ROS-Industrial controller frames.
// These fixed signs and zero offsets keep the model flange coincident with the
// procedural Chain end transform for every joint pose.
const $02d7f5d4efaaabf0$var$chainToModelJointTransforms = [
    (value)=>-value,
    (value)=>-value,
    (value)=>Math.PI / 2 - value,
    (value)=>-Math.PI - value,
    (value)=>value,
    (value)=>-value
];
function $02d7f5d4efaaabf0$export$8ebb04576aba4652(values = []) {
    if (Array.isArray(values)) return $02d7f5d4efaaabf0$var$chainToModelJointTransforms.map((transform, index)=>transform(values[index] ?? 0));
    const mappedValues = {};
    for(let index = 0; index < $02d7f5d4efaaabf0$var$chainToModelJointTransforms.length; index++){
        const key = `j${index + 1}`;
        if (values[key] === undefined) continue;
        mappedValues[key] = $02d7f5d4efaaabf0$var$chainToModelJointTransforms[index](values[key]);
    }
    return mappedValues;
}
function $02d7f5d4efaaabf0$export$7f9d24645879809c({ parent: parent, assetUrl: assetUrl, rootTransform: rootTransform = {}, materialResolver: materialResolver = null } = {}) {
    const rig = new (0, $kjkPx.ModelRig)({
        parent: parent,
        name: 'KUKA KR5 model rig',
        assetUrl: assetUrl,
        rootTransform: rootTransform,
        materialResolver: materialResolver,
        jointValueMapper: $02d7f5d4efaaabf0$export$8ebb04576aba4652
    });
    // Joint origins follow the ROS-Industrial KR5 ARC Xacro frames.
    rig.addJoint('j1', {
        name: 'A1',
        position: [
            0,
            0,
            0.4
        ],
        rpy: [
            Math.PI,
            0,
            0
        ]
    });
    rig.addJoint('j2', {
        parent: 'j1',
        name: 'A2',
        position: [
            0.18,
            0,
            0
        ],
        rpy: [
            Math.PI / 2,
            0,
            0
        ]
    });
    rig.addJoint('j3', {
        parent: 'j2',
        name: 'A3',
        position: [
            0.6,
            0,
            0
        ]
    });
    rig.addJoint('j4', {
        parent: 'j3',
        name: 'A4',
        position: [
            0,
            -0.12,
            0
        ],
        rpy: [
            0,
            -Math.PI / 2,
            0
        ]
    });
    rig.addJoint('j5', {
        parent: 'j4',
        name: 'A5',
        position: [
            0,
            0,
            -0.62
        ],
        rpy: [
            0,
            Math.PI / 2,
            0
        ]
    });
    rig.addJoint('j6', {
        parent: 'j5',
        name: 'A6',
        rpy: [
            0,
            -Math.PI / 2,
            0
        ]
    });
    rig.addFrame('tool0', {
        parent: 'j6',
        name: 'KUKA flange',
        position: [
            0,
            0,
            -0.115
        ],
        rpy: [
            0,
            -Math.PI,
            -Math.PI / 2
        ]
    });
    rig.addVisual({
        file: 'base_link.dae'
    }).addVisual({
        file: 'link_1.dae',
        parent: 'j1'
    }).addVisual({
        file: 'link_2.dae',
        parent: 'j2'
    }).addVisual({
        file: 'link_3.dae',
        parent: 'j3'
    }).addVisual({
        file: 'link_4.dae',
        parent: 'j4'
    }).addVisual({
        file: 'link_5.dae',
        parent: 'j5'
    }).addVisual({
        file: 'link_6.dae',
        parent: 'j6'
    });
    return rig;
}



var $64d2U = parcelRequire("64d2U");
let $221af0fce368de33$var$scene, $221af0fce368de33$var$camera, $221af0fce368de33$var$renderer, $221af0fce368de33$var$controls, $221af0fce368de33$var$pane;
let $221af0fce368de33$var$chain;
let $221af0fce368de33$var$actuator;
let $221af0fce368de33$var$chainSolver;
let $221af0fce368de33$var$profileInfoBlock;
let $221af0fce368de33$var$solveStatsBlock;
let $221af0fce368de33$var$showModelBinding;
let $221af0fce368de33$var$qCurrent = [];
let $221af0fce368de33$var$isSolving = false;
let $221af0fce368de33$var$isSyncingTarget = false;
let $221af0fce368de33$var$isDraggingTarget = false;
let $221af0fce368de33$var$pendingSolve = false;
const $221af0fce368de33$var$pendingTarget = new (0, $jw0R5.Vector3)();
const $221af0fce368de33$var$pendingTargetQuat = new (0, $jw0R5.Quaternion)();
let $221af0fce368de33$var$solveActive = false;
let $221af0fce368de33$var$targetTolerance = 1e-2;
let $221af0fce368de33$var$solveStartedAt = 0;
let $221af0fce368de33$var$accumulatedSolveMs = 0;
let $221af0fce368de33$var$accumulatedIterations = 0;
let $221af0fce368de33$var$solveCallCount = 0;
const $221af0fce368de33$var$BG_COLOR = 0x242a2e;
const $221af0fce368de33$var$FRAME_RATE = 60;
const $221af0fce368de33$var$DEFAULT_EXPOSURE = 1.2;
const $221af0fce368de33$var$KUKA_MODEL_URL = `${(0, $6BOAB.getAssetURL)()}models/kuka-kr5/visual/`;
const $221af0fce368de33$var$UR3E_MODEL_URL = `${(0, $6BOAB.getAssetURL)()}models/ur3e/visual/`;
const $221af0fce368de33$var$renderLoop = (0, $6BOAB.getRenderLoopController)();
const $221af0fce368de33$var$modelRigEntries = new Map();
const $221af0fce368de33$var$styleParams = {
    jointColor: 0x7d7d7d,
    linkColor: 0x000000,
    randomJointColor: true,
    randomLinkColor: false,
    jointRadius: 0.035,
    jointHeight: 0.12,
    linkRadius: 0.01,
    trimLinksAtJoints: true,
    linkJointOverlap: 0.01,
    showAxisHelper: false,
    showDOFHelper: false,
    dofColor: 0xffa500,
    dofOpacity: 0.25,
    dofUseJointColor: true,
    dofUseAutoRadius: false,
    dofRadius: 0.1,
    dofRadiusScale: 0.5,
    dofThicknessRatio: 0.3,
    dofSegments: 64,
    dofOffsetZ: 1e-4,
    axisHelperSize: 0.1,
    syncUp: true,
    litMaterials: true,
    roughness: 0.42,
    metalness: 0.24,
    castShadow: true,
    receiveShadow: true
};
const $221af0fce368de33$var$baseParams = {
    mdhMode: false,
    baseOffset: {
        x: 0,
        y: 0,
        z: 0
    }
};
const $221af0fce368de33$var$solverParams = {
    solverMethod: 'DLS',
    maxIter: 20,
    alpha: 0.05,
    tolerance: $221af0fce368de33$var$targetTolerance,
    damping: 0.04,
    dlsMaxDelta: 0.08,
    rotationWeight: 0.25,
    rotationTolerance: 0.03,
    solveMode: 'Position Only',
    solveImmediately: false,
    debug: false
};
const $221af0fce368de33$var$solveStats = {
    status: 'Idle',
    solveTime: '--',
    wallTime: '--',
    iterations: '0',
    calls: '0',
    error: '--'
};
const $221af0fce368de33$var$viewParams = {
    showModel: true
};
const $221af0fce368de33$var$modelParams = {
    preset: 'kuka-kr5'
};
const $221af0fce368de33$var$sharedIkVisualStyle = {
    jointColor: 0x7d7d7d,
    linkColor: 0x171a1c,
    randomJointColor: true,
    jointRadius: 0.025,
    jointHeight: 0.12,
    linkRadius: 0.01
};
const $221af0fce368de33$var$ur3eVisualStyle = {
    ...$221af0fce368de33$var$sharedIkVisualStyle,
    jointRadius: $221af0fce368de33$var$sharedIkVisualStyle.jointRadius * 0.65,
    jointHeight: $221af0fce368de33$var$sharedIkVisualStyle.jointHeight * 0.65
};
const $221af0fce368de33$var$modelPresets = {
    'kuka-kr5': {
        profile: (0, $bMVXx.kukaKr5ChainProfile),
        style: $221af0fce368de33$var$sharedIkVisualStyle,
        cameraPosition: [
            1.5,
            1.3,
            1.5
        ],
        cameraTarget: [
            0.25,
            0.5,
            -0.25
        ]
    },
    'universal-robots-ur3e': {
        profile: (0, $bMVXx.ur3eChainProfile),
        style: $221af0fce368de33$var$ur3eVisualStyle,
        cameraPosition: [
            0.66,
            0.55,
            0.66
        ],
        cameraTarget: [
            0.08,
            0.24,
            -0.08
        ]
    }
};
let $221af0fce368de33$var$activeProfile = $221af0fce368de33$var$modelPresets[$221af0fce368de33$var$modelParams.preset].profile;
$221af0fce368de33$var$init();
function $221af0fce368de33$var$init() {
    $221af0fce368de33$var$scene = new (0, $jw0R5.Scene)();
    $221af0fce368de33$var$scene.background = new (0, $jw0R5.Color)($221af0fce368de33$var$BG_COLOR);
    $221af0fce368de33$var$camera = new (0, $jw0R5.PerspectiveCamera)(55, window.innerWidth / window.innerHeight, 0.1, 1000);
    $221af0fce368de33$var$camera.position.set(2, 2, 2);
    $221af0fce368de33$var$renderer = new (0, $jw0R5.WebGLRenderer)({
        antialias: true
    });
    $221af0fce368de33$var$renderer.setPixelRatio(window.devicePixelRatio);
    $221af0fce368de33$var$renderer.setSize(window.innerWidth, window.innerHeight);
    $221af0fce368de33$var$renderer.setClearColor($221af0fce368de33$var$BG_COLOR, 1);
    $221af0fce368de33$var$renderer.outputColorSpace = (0, $jw0R5.SRGBColorSpace);
    $221af0fce368de33$var$renderer.toneMapping = (0, $jw0R5.ACESFilmicToneMapping);
    $221af0fce368de33$var$renderer.toneMappingExposure = $221af0fce368de33$var$DEFAULT_EXPOSURE;
    $221af0fce368de33$var$renderer.shadowMap.enabled = true;
    $221af0fce368de33$var$renderer.shadowMap.type = (0, $jw0R5.PCFSoftShadowMap);
    document.body.appendChild($221af0fce368de33$var$renderer.domElement);
    $221af0fce368de33$var$controls = new (0, $2sw9m.OrbitControls)($221af0fce368de33$var$camera, $221af0fce368de33$var$renderer.domElement);
    $221af0fce368de33$var$controls.target.set(0, 0, 0.5);
    $221af0fce368de33$var$controls.update();
    $221af0fce368de33$var$controls.addEventListener('change', ()=>{
        $221af0fce368de33$var$renderLoop.requestRender();
    });
    $221af0fce368de33$var$addEnvironment();
    $221af0fce368de33$var$chain = new (0, $bPqRC.Chain)($221af0fce368de33$var$scene);
    $221af0fce368de33$var$actuator = $221af0fce368de33$var$createActuator($221af0fce368de33$var$scene, $221af0fce368de33$var$camera, $221af0fce368de33$var$renderer.domElement);
    $221af0fce368de33$var$chainSolver = new (0, $2hZdK.default)({
        targetPosition: new (0, $jw0R5.Vector3)(),
        targetQuaternion: new (0, $jw0R5.Quaternion)(),
        chain: $221af0fce368de33$var$chain,
        maxIter: $221af0fce368de33$var$solverParams.maxIter,
        alpha: $221af0fce368de33$var$solverParams.alpha,
        tolerance: $221af0fce368de33$var$solverParams.tolerance,
        solveMode: $221af0fce368de33$var$solverParams.solveMode,
        solverMethod: $221af0fce368de33$var$solverParams.solverMethod,
        damping: $221af0fce368de33$var$solverParams.damping,
        dlsMaxDelta: $221af0fce368de33$var$solverParams.dlsMaxDelta,
        rotationWeight: $221af0fce368de33$var$solverParams.rotationWeight,
        rotationTolerance: $221af0fce368de33$var$solverParams.rotationTolerance,
        debug: $221af0fce368de33$var$solverParams.debug,
        forwardKinematics: (q)=>{
            $221af0fce368de33$var$chain.updateJoint(q);
        }
    });
    $221af0fce368de33$var$actuator.controls.addEventListener('dragging-changed', (event)=>{
        $221af0fce368de33$var$controls.enabled = !event.value;
        $221af0fce368de33$var$isDraggingTarget = event.value;
        if (!$221af0fce368de33$var$isDraggingTarget) // Default behavior: solve once after drag end (mouse up).
        $221af0fce368de33$var$queueSolveFromTarget();
        $221af0fce368de33$var$renderLoop.requestRender();
    });
    $221af0fce368de33$var$actuator.controls.addEventListener('change', ()=>{
        if ($221af0fce368de33$var$isDraggingTarget && $221af0fce368de33$var$solverParams.solveImmediately) $221af0fce368de33$var$queueSolveFromTarget();
        $221af0fce368de33$var$renderLoop.requestRender();
    });
    $221af0fce368de33$var$renderLoop.configure({
        fps: $221af0fce368de33$var$FRAME_RATE,
        render: $221af0fce368de33$var$renderFrame
    });
    $221af0fce368de33$var$renderLoop.setContinuous(false);
    $221af0fce368de33$var$renderLoop.setRenderOnIdle(false);
    $221af0fce368de33$var$pane = new (0, $ctZJO.Pane)({
        title: 'IK',
        container: document.getElementById('control-panel')
    });
    const modelFolder = $221af0fce368de33$var$pane.addFolder({
        title: 'Robot Model'
    });
    modelFolder.addBinding($221af0fce368de33$var$modelParams, 'preset', {
        label: 'Preset',
        options: {
            'KUKA KR5': 'kuka-kr5',
            'UR3e (Official DH)': 'universal-robots-ur3e'
        }
    }).on('change', (ev)=>{
        $221af0fce368de33$var$selectModelPreset(ev.value);
    });
    $221af0fce368de33$var$profileInfoBlock = $221af0fce368de33$var$addProfileInfoBlock(modelFolder);
    modelFolder.expanded = true;
    const vizFolder = $221af0fce368de33$var$pane.addFolder({
        title: 'Visualization'
    });
    $221af0fce368de33$var$showModelBinding = vizFolder.addBinding($221af0fce368de33$var$viewParams, 'showModel', {
        label: 'Show Model'
    }).on('change', (ev)=>{
        $221af0fce368de33$var$viewParams.showModel = ev.value;
        $221af0fce368de33$var$updateModelPresentation();
    });
    vizFolder.addBinding($221af0fce368de33$var$styleParams, 'syncUp', {
        label: 'Sync Up'
    }).on('change', (ev)=>{
        if (ev.last === false) return;
        $221af0fce368de33$var$updateArm();
    });
    const helpersFolder = vizFolder.addFolder({
        title: 'Helpers'
    });
    helpersFolder.addBinding($221af0fce368de33$var$styleParams, 'showAxisHelper', {
        label: 'Axis Helper'
    }).on('change', (ev)=>{
        if (ev.last === false) return;
        $221af0fce368de33$var$updateArm();
    });
    helpersFolder.addBinding($221af0fce368de33$var$styleParams, 'showDOFHelper', {
        label: 'DOF Helper'
    }).on('change', (ev)=>{
        if (ev.last === false) return;
        $221af0fce368de33$var$updateArm();
    });
    helpersFolder.expanded = true;
    vizFolder.expanded = true;
    const controlsFolder = $221af0fce368de33$var$pane.addFolder({
        title: 'Control'
    });
    controlsFolder.addButton({
        title: 'Reset'
    }).on('click', ()=>{
        $221af0fce368de33$var$resetAll();
    });
    controlsFolder.addBinding($221af0fce368de33$var$solverParams, 'debug', {
        label: 'Debug'
    }).on('change', (ev)=>{
        if ($221af0fce368de33$var$chainSolver) $221af0fce368de33$var$chainSolver.debug = ev.value;
    });
    controlsFolder.addBinding($221af0fce368de33$var$solverParams, 'solveImmediately', {
        label: 'Solve Immediately'
    });
    controlsFolder.addBinding($221af0fce368de33$var$solverParams, 'solverMethod', {
        label: 'Algorithm',
        options: {
            'Basic IK': 'Jacobian',
            DLS: 'DLS'
        }
    }).on('change', (ev)=>{
        if ($221af0fce368de33$var$chainSolver) $221af0fce368de33$var$chainSolver.solverMethod = ev.value;
        $221af0fce368de33$var$queueSolveFromTarget();
    });
    controlsFolder.addBinding($221af0fce368de33$var$solverParams, 'maxIter', {
        label: 'Max Iter',
        min: 1,
        max: 200,
        step: 1
    }).on('change', (ev)=>{
        if ($221af0fce368de33$var$chainSolver) $221af0fce368de33$var$chainSolver.maxIter = ev.value;
    });
    controlsFolder.addBinding($221af0fce368de33$var$solverParams, 'alpha', {
        label: 'Alpha',
        min: 0.001,
        max: 0.5,
        step: 0.001
    }).on('change', (ev)=>{
        if ($221af0fce368de33$var$chainSolver) $221af0fce368de33$var$chainSolver.alpha = ev.value;
    });
    controlsFolder.addBinding($221af0fce368de33$var$solverParams, 'damping', {
        label: 'Damping',
        min: 1e-5,
        max: 1,
        step: 0.001
    }).on('change', (ev)=>{
        if ($221af0fce368de33$var$chainSolver) $221af0fce368de33$var$chainSolver.damping = ev.value;
    });
    controlsFolder.addBinding($221af0fce368de33$var$solverParams, 'dlsMaxDelta', {
        label: 'DLS Max Delta',
        min: 0.001,
        max: 0.5,
        step: 0.001
    }).on('change', (ev)=>{
        if ($221af0fce368de33$var$chainSolver) $221af0fce368de33$var$chainSolver.dlsMaxDelta = ev.value;
    });
    controlsFolder.addBinding($221af0fce368de33$var$solverParams, 'tolerance', {
        label: 'Tolerance',
        min: 1e-5,
        max: 1e-1,
        step: 1e-5
    }).on('change', (ev)=>{
        if ($221af0fce368de33$var$chainSolver) $221af0fce368de33$var$chainSolver.tolerance = ev.value;
        $221af0fce368de33$var$targetTolerance = ev.value;
    });
    const statsFolder = controlsFolder.addFolder({
        title: 'Solve Statistics'
    });
    $221af0fce368de33$var$solveStatsBlock = $221af0fce368de33$var$addSolveStatsBlock(statsFolder);
    $221af0fce368de33$var$updateSolveStatsBlock();
    statsFolder.expanded = true;
    controlsFolder.expanded = true;
    $221af0fce368de33$var$applyPresetStyle();
    $221af0fce368de33$var$buildRobot();
    $221af0fce368de33$var$frameActiveProfile();
    $221af0fce368de33$var$updateProfileInfo();
    $221af0fce368de33$var$updateModelBinding();
    window.addEventListener('resize', $221af0fce368de33$var$onResize);
    $221af0fce368de33$var$renderLoop.requestRender();
}
function $221af0fce368de33$var$addEnvironment() {
    const floor = new (0, $jw0R5.Mesh)(new (0, $jw0R5.PlaneGeometry)(20, 20), new (0, $jw0R5.MeshStandardMaterial)({
        color: 0x596064,
        roughness: 0.82,
        metalness: 0.05
    }));
    floor.rotation.x = -Math.PI / 2;
    floor.position.y = -0.012;
    floor.receiveShadow = true;
    $221af0fce368de33$var$scene.add(floor);
    const grid = new (0, $jw0R5.GridHelper)(20, 20, 0x7b8589, 0x687175);
    grid.position.y = -0.005;
    grid.material.transparent = true;
    grid.material.opacity = 0.24;
    $221af0fce368de33$var$scene.add(grid);
    $221af0fce368de33$var$scene.add(new (0, $jw0R5.AmbientLight)(0xffffff, 0.58));
    const hemisphere = new (0, $jw0R5.HemisphereLight)(0xf5fbff, 0x32383b, 1.45);
    hemisphere.position.set(0, 8, 0);
    $221af0fce368de33$var$scene.add(hemisphere);
    const key = new (0, $jw0R5.DirectionalLight)(0xffffff, 4.2);
    key.position.set(5, 8, 6);
    key.castShadow = true;
    key.shadow.mapSize.set(2048, 2048);
    key.shadow.camera.left = -3;
    key.shadow.camera.right = 3;
    key.shadow.camera.top = 4;
    key.shadow.camera.bottom = -2;
    key.shadow.camera.near = 0.5;
    key.shadow.camera.far = 24;
    $221af0fce368de33$var$scene.add(key);
    const fill = new (0, $jw0R5.DirectionalLight)(0xb9dcff, 1.3);
    fill.position.set(-5, 4, 4);
    $221af0fce368de33$var$scene.add(fill);
    const rim = new (0, $jw0R5.DirectionalLight)(0xc0ecff, 1.45);
    rim.position.set(-3, 5, -6);
    $221af0fce368de33$var$scene.add(rim);
}
function $221af0fce368de33$var$createModelRig(presetKey) {
    const preset = $221af0fce368de33$var$modelPresets[presetKey];
    if (!preset) return null;
    const rig = presetKey === 'kuka-kr5' ? (0, $02d7f5d4efaaabf0$export$7f9d24645879809c)({
        parent: $221af0fce368de33$var$scene,
        assetUrl: $221af0fce368de33$var$KUKA_MODEL_URL
    }) : (0, $64d2U.createUr3eRig)({
        parent: $221af0fce368de33$var$scene,
        assetUrl: $221af0fce368de33$var$UR3E_MODEL_URL
    });
    rig.syncBase({
        syncUp: $221af0fce368de33$var$styleParams.syncUp,
        offset: $221af0fce368de33$var$baseParams.baseOffset
    });
    rig.setJointValues($221af0fce368de33$var$qCurrent);
    rig.setVisible(false);
    const entry = {
        rig: rig,
        ready: false,
        loadPromise: null
    };
    $221af0fce368de33$var$modelRigEntries.set(presetKey, entry);
    return entry;
}
function $221af0fce368de33$var$getModelRigEntry(presetKey = $221af0fce368de33$var$modelParams.preset) {
    return $221af0fce368de33$var$modelRigEntries.get(presetKey) || $221af0fce368de33$var$createModelRig(presetKey);
}
function $221af0fce368de33$var$ensureModelRig(presetKey = $221af0fce368de33$var$modelParams.preset) {
    const entry = $221af0fce368de33$var$getModelRigEntry(presetKey);
    if (!entry) return Promise.reject(new Error(`Unknown robot preset: ${presetKey}`));
    if (entry.ready) return Promise.resolve(entry.rig);
    if (entry.loadPromise) return entry.loadPromise;
    entry.loadPromise = entry.rig.load().then(()=>{
        entry.ready = true;
        return entry.rig;
    }).catch((error)=>{
        console.error(`Unable to load the ${presetKey} model.`, error);
        entry.rig.removeFromParent();
        $221af0fce368de33$var$modelRigEntries.delete(presetKey);
        throw error;
    });
    return entry.loadPromise;
}
function $221af0fce368de33$var$syncModelRigTransforms() {
    for (const [presetKey, entry] of $221af0fce368de33$var$modelRigEntries){
        entry.rig.syncBase({
            syncUp: $221af0fce368de33$var$styleParams.syncUp,
            offset: $221af0fce368de33$var$baseParams.baseOffset
        });
        if (presetKey === $221af0fce368de33$var$modelParams.preset) entry.rig.setJointValues($221af0fce368de33$var$qCurrent);
    }
}
function $221af0fce368de33$var$syncActiveModelPose() {
    $221af0fce368de33$var$modelRigEntries.get($221af0fce368de33$var$modelParams.preset)?.rig.setJointValues($221af0fce368de33$var$qCurrent);
}
function $221af0fce368de33$var$updateModelPresentation() {
    $221af0fce368de33$var$syncModelRigTransforms();
    const shouldShowModel = $221af0fce368de33$var$viewParams.showModel;
    const activeEntry = shouldShowModel ? $221af0fce368de33$var$getModelRigEntry() : null;
    const modelVisible = shouldShowModel && activeEntry?.ready;
    for (const [presetKey, entry] of $221af0fce368de33$var$modelRigEntries)entry.rig.setVisible(modelVisible && presetKey === $221af0fce368de33$var$modelParams.preset);
    if ($221af0fce368de33$var$chain?.roboticArm) $221af0fce368de33$var$chain.roboticArm.visible = !modelVisible;
    if (shouldShowModel && activeEntry && !activeEntry.ready) $221af0fce368de33$var$ensureModelRig().then(()=>{
        $221af0fce368de33$var$updateModelPresentation();
        $221af0fce368de33$var$renderLoop.requestRender();
    }).catch(()=>{
        $221af0fce368de33$var$viewParams.showModel = false;
        $221af0fce368de33$var$updateModelBinding();
        $221af0fce368de33$var$updateModelPresentation();
        $221af0fce368de33$var$renderLoop.requestRender();
    });
    $221af0fce368de33$var$renderLoop.requestRender();
}
function $221af0fce368de33$var$createActuator(scene, camera, domElement) {
    const object = new (0, $jw0R5.Object3D)();
    object.name = 'actuator';
    object.matrixAutoUpdate = true;
    scene.add(object);
    const sphere = new (0, $jw0R5.Mesh)(new (0, $jw0R5.SphereGeometry)(0.04, 16, 16), new (0, $jw0R5.MeshBasicMaterial)({
        color: 0xff4444
    }));
    object.add(sphere);
    const controls = new (0, $lsYJx.TransformControls)(camera, domElement);
    controls.setMode('translate');
    controls.setSpace('local');
    controls.attach(object);
    scene.add(controls);
    return {
        object: object,
        controls: controls,
        getWorldPosition (out = new (0, $jw0R5.Vector3)()) {
            if (object.parent) object.parent.updateMatrixWorld(true);
            else object.updateMatrixWorld(true, false);
            return object.getWorldPosition(out);
        },
        getWorldQuaternion (out = new (0, $jw0R5.Quaternion)()) {
            if (object.parent) object.parent.updateMatrixWorld(true);
            else object.updateMatrixWorld(true, false);
            return object.getWorldQuaternion(out);
        },
        setLocalPosition (localPosition) {
            object.position.copy(localPosition);
        },
        setLocalQuaternion (localQuaternion) {
            object.quaternion.copy(localQuaternion);
        }
    };
}
function $221af0fce368de33$var$buildRobot() {
    $221af0fce368de33$var$qCurrent = (0, $bMVXx.createInitialJointState)($221af0fce368de33$var$activeProfile);
    $221af0fce368de33$var$chain.update((0, $bMVXx.createDhParametersFromJointState)($221af0fce368de33$var$qCurrent, $221af0fce368de33$var$activeProfile), $221af0fce368de33$var$styleParams, $221af0fce368de33$var$baseParams);
    $221af0fce368de33$var$attachActuator();
    $221af0fce368de33$var$updateActuator();
    if ($221af0fce368de33$var$chainSolver) $221af0fce368de33$var$chainSolver.joints = $221af0fce368de33$var$chain.joints;
    $221af0fce368de33$var$updateModelPresentation();
    $221af0fce368de33$var$renderLoop.requestRender();
}
function $221af0fce368de33$var$updateArm() {
    $221af0fce368de33$var$chain.update((0, $bMVXx.createDhParametersFromJointState)($221af0fce368de33$var$qCurrent, $221af0fce368de33$var$activeProfile), $221af0fce368de33$var$styleParams, $221af0fce368de33$var$baseParams);
    $221af0fce368de33$var$attachActuator();
    $221af0fce368de33$var$updateActuator();
    if ($221af0fce368de33$var$chainSolver) $221af0fce368de33$var$chainSolver.joints = $221af0fce368de33$var$chain.joints;
    $221af0fce368de33$var$updateModelPresentation();
    $221af0fce368de33$var$renderLoop.requestRender();
}
function $221af0fce368de33$var$selectModelPreset(presetKey) {
    if (!$221af0fce368de33$var$modelPresets[presetKey]) return;
    $221af0fce368de33$var$pendingSolve = false;
    $221af0fce368de33$var$solveActive = false;
    $221af0fce368de33$var$isSolving = false;
    $221af0fce368de33$var$resetSolveStats();
    $221af0fce368de33$var$modelParams.preset = presetKey;
    $221af0fce368de33$var$activeProfile = $221af0fce368de33$var$modelPresets[presetKey].profile;
    $221af0fce368de33$var$updateModelBinding();
    $221af0fce368de33$var$applyPresetStyle();
    $221af0fce368de33$var$buildRobot();
    $221af0fce368de33$var$frameActiveProfile();
    $221af0fce368de33$var$updateProfileInfo();
    $221af0fce368de33$var$renderLoop.requestRender();
}
function $221af0fce368de33$var$applyPresetStyle() {
    const preset = $221af0fce368de33$var$modelPresets[$221af0fce368de33$var$modelParams.preset];
    if (!preset) return;
    Object.assign($221af0fce368de33$var$styleParams, preset.style);
}
function $221af0fce368de33$var$updateModelBinding() {
    if (!$221af0fce368de33$var$showModelBinding) return;
    $221af0fce368de33$var$showModelBinding.disabled = false;
    $221af0fce368de33$var$showModelBinding.refresh();
}
function $221af0fce368de33$var$frameActiveProfile() {
    const preset = $221af0fce368de33$var$modelPresets[$221af0fce368de33$var$modelParams.preset];
    if (!preset) return;
    $221af0fce368de33$var$camera.position.fromArray(preset.cameraPosition);
    $221af0fce368de33$var$controls.target.fromArray(preset.cameraTarget);
    $221af0fce368de33$var$controls.update();
}
function $221af0fce368de33$var$addProfileInfoBlock(folder) {
    const block = document.createElement('div');
    block.style.boxSizing = 'border-box';
    block.style.width = '100%';
    block.style.maxHeight = '190px';
    block.style.overflow = 'auto';
    block.style.padding = '8px 10px';
    block.style.marginTop = '4px';
    block.style.borderTop = '1px solid rgba(255, 255, 255, 0.12)';
    block.style.background = 'rgba(0, 0, 0, 0.24)';
    block.style.color = '#d8fbff';
    block.style.fontFamily = 'monospace';
    block.style.fontSize = '10px';
    block.style.lineHeight = '1.45';
    block.style.whiteSpace = 'pre';
    folder.element.appendChild(block);
    return block;
}
function $221af0fce368de33$var$addSolveStatsBlock(folder) {
    const block = $221af0fce368de33$var$addProfileInfoBlock(folder);
    block.style.maxHeight = 'none';
    block.style.color = '#f4f7f8';
    return block;
}
function $221af0fce368de33$var$updateSolveStatsBlock() {
    if (!$221af0fce368de33$var$solveStatsBlock) return;
    const algorithm = $221af0fce368de33$var$solverParams.solverMethod === 'DLS' ? 'DLS' : 'Basic IK';
    $221af0fce368de33$var$solveStatsBlock.textContent = [
        `Algorithm    ${algorithm}`,
        `Status       ${$221af0fce368de33$var$solveStats.status}`,
        `Solve Time   ${$221af0fce368de33$var$solveStats.solveTime}`,
        `Wall Time    ${$221af0fce368de33$var$solveStats.wallTime}`,
        `Iterations   ${$221af0fce368de33$var$solveStats.iterations}`,
        `Solve Calls  ${$221af0fce368de33$var$solveStats.calls}`,
        `Residual     ${$221af0fce368de33$var$solveStats.error}`
    ].join('\n');
}
function $221af0fce368de33$var$resetSolveStats(status = 'Idle') {
    $221af0fce368de33$var$solveStartedAt = 0;
    $221af0fce368de33$var$accumulatedSolveMs = 0;
    $221af0fce368de33$var$accumulatedIterations = 0;
    $221af0fce368de33$var$solveCallCount = 0;
    $221af0fce368de33$var$solveStats.status = status;
    $221af0fce368de33$var$solveStats.solveTime = '--';
    $221af0fce368de33$var$solveStats.wallTime = '--';
    $221af0fce368de33$var$solveStats.iterations = '0';
    $221af0fce368de33$var$solveStats.calls = '0';
    $221af0fce368de33$var$solveStats.error = '--';
    $221af0fce368de33$var$updateSolveStatsBlock();
}
function $221af0fce368de33$var$beginSolveMeasurement() {
    $221af0fce368de33$var$resetSolveStats('Solving');
    $221af0fce368de33$var$solveStartedAt = performance.now();
    $221af0fce368de33$var$solveStats.solveTime = '0.000 ms';
    $221af0fce368de33$var$solveStats.wallTime = '0.000 ms';
    $221af0fce368de33$var$updateSolveStatsBlock();
}
function $221af0fce368de33$var$updateSolveMeasurement(stepSolveMs, remainingError, converged) {
    $221af0fce368de33$var$accumulatedSolveMs += stepSolveMs;
    $221af0fce368de33$var$accumulatedIterations += $221af0fce368de33$var$chainSolver.lastIterationCount;
    $221af0fce368de33$var$solveCallCount += 1;
    $221af0fce368de33$var$solveStats.status = converged ? 'Converged' : 'Solving';
    $221af0fce368de33$var$solveStats.solveTime = `${$221af0fce368de33$var$accumulatedSolveMs.toFixed(3)} ms`;
    $221af0fce368de33$var$solveStats.wallTime = `${(performance.now() - $221af0fce368de33$var$solveStartedAt).toFixed(3)} ms`;
    $221af0fce368de33$var$solveStats.iterations = String($221af0fce368de33$var$accumulatedIterations);
    $221af0fce368de33$var$solveStats.calls = String($221af0fce368de33$var$solveCallCount);
    $221af0fce368de33$var$solveStats.error = remainingError.toExponential(3);
    $221af0fce368de33$var$updateSolveStatsBlock();
}
function $221af0fce368de33$var$updateProfileInfo() {
    if (!$221af0fce368de33$var$profileInfoBlock || !$221af0fce368de33$var$activeProfile) return;
    const title = $221af0fce368de33$var$activeProfile === (0, $bMVXx.ur3eChainProfile) ? 'UR3e standard DH (metres)' : 'KUKA KR5 DH (metres)';
    const rows = $221af0fce368de33$var$activeProfile.segments.map((segment, index)=>{
        const d = segment.d.toFixed(5);
        const a = segment.a.toFixed(5);
        const alpha = `${segment.alpha}\xb0`;
        return `J${index + 1}  d ${d}  a ${a}  \u{3B1} ${alpha}`;
    });
    $221af0fce368de33$var$profileInfoBlock.textContent = [
        title,
        ...rows
    ].join('\n');
}
function $221af0fce368de33$var$attachActuator() {
    if (!$221af0fce368de33$var$chain.robotContainer) return;
    if ($221af0fce368de33$var$actuator.object.parent !== $221af0fce368de33$var$chain.robotContainer) $221af0fce368de33$var$chain.robotContainer.attach($221af0fce368de33$var$actuator.object);
}
function $221af0fce368de33$var$updateActuator() {
    if (!$221af0fce368de33$var$chain.roboticArm) return;
    const actuatorLocalPosition = $221af0fce368de33$var$chain.getActuatorLocalPosition();
    const actuatorLocalQuaternion = $221af0fce368de33$var$chain.getActuatorLocalQuaternion(new (0, $jw0R5.Quaternion)());
    if (actuatorLocalPosition) {
        $221af0fce368de33$var$isSyncingTarget = true;
        try {
            $221af0fce368de33$var$actuator.setLocalPosition(actuatorLocalPosition);
            if (actuatorLocalQuaternion) $221af0fce368de33$var$actuator.setLocalQuaternion(actuatorLocalQuaternion);
        } finally{
            $221af0fce368de33$var$isSyncingTarget = false;
        }
    }
}
function $221af0fce368de33$var$queueSolveFromTarget() {
    if (!$221af0fce368de33$var$chain.roboticArm || $221af0fce368de33$var$isSyncingTarget) return;
    $221af0fce368de33$var$syncPendingTargetFromControl();
    $221af0fce368de33$var$beginSolveMeasurement();
    $221af0fce368de33$var$pendingSolve = true;
    $221af0fce368de33$var$solveActive = true;
    $221af0fce368de33$var$renderLoop.requestRender();
}
function $221af0fce368de33$var$syncPendingTargetFromControl() {
    if (!$221af0fce368de33$var$actuator) return;
    $221af0fce368de33$var$actuator.getWorldPosition($221af0fce368de33$var$pendingTarget);
    $221af0fce368de33$var$actuator.getWorldQuaternion($221af0fce368de33$var$pendingTargetQuat);
}
function $221af0fce368de33$var$solveIfPending() {
    if (!$221af0fce368de33$var$pendingSolve && !$221af0fce368de33$var$solveActive || $221af0fce368de33$var$isSolving || !$221af0fce368de33$var$chain.roboticArm) return;
    $221af0fce368de33$var$pendingSolve = false;
    $221af0fce368de33$var$chainSolver.targetPosition.copy($221af0fce368de33$var$pendingTarget);
    $221af0fce368de33$var$chainSolver.targetQuaternion.copy($221af0fce368de33$var$pendingTargetQuat);
    $221af0fce368de33$var$isSolving = true;
    const solveStepStartedAt = performance.now();
    try {
        $221af0fce368de33$var$qCurrent = $221af0fce368de33$var$chainSolver.solve($221af0fce368de33$var$qCurrent);
        $221af0fce368de33$var$chain.updateJoint($221af0fce368de33$var$qCurrent);
        $221af0fce368de33$var$syncActiveModelPose();
    } finally{
        $221af0fce368de33$var$isSolving = false;
    }
    const solveStepMs = performance.now() - solveStepStartedAt;
    const remainingError = $221af0fce368de33$var$chainSolver.computeSolveErrorNorm($221af0fce368de33$var$qCurrent);
    const converged = remainingError <= $221af0fce368de33$var$targetTolerance;
    $221af0fce368de33$var$updateSolveMeasurement(solveStepMs, remainingError, converged);
    if (!converged) {
        $221af0fce368de33$var$solveActive = true;
        $221af0fce368de33$var$pendingSolve = true;
    } else $221af0fce368de33$var$solveActive = false;
}
function $221af0fce368de33$var$resetAll() {
    $221af0fce368de33$var$pendingSolve = false;
    $221af0fce368de33$var$solveActive = false;
    $221af0fce368de33$var$isSolving = false;
    if ($221af0fce368de33$var$actuator && $221af0fce368de33$var$actuator.controls) $221af0fce368de33$var$actuator.controls.setMode('translate');
    if ($221af0fce368de33$var$actuator && $221af0fce368de33$var$actuator.object) $221af0fce368de33$var$actuator.object.rotation.set(0, 0, 0);
    $221af0fce368de33$var$resetSolveStats();
    $221af0fce368de33$var$buildRobot();
}
function $221af0fce368de33$var$onResize() {
    const width = window.innerWidth;
    const height = window.innerHeight;
    $221af0fce368de33$var$renderer.setSize(width, height);
    $221af0fce368de33$var$camera.aspect = width / height;
    $221af0fce368de33$var$camera.updateProjectionMatrix();
    $221af0fce368de33$var$renderLoop.requestRender();
}
function $221af0fce368de33$var$renderFrame() {
    $221af0fce368de33$var$solveIfPending();
    $221af0fce368de33$var$renderer.render($221af0fce368de33$var$scene, $221af0fce368de33$var$camera);
    if ($221af0fce368de33$var$pendingSolve || $221af0fce368de33$var$solveActive || $221af0fce368de33$var$isSolving) $221af0fce368de33$var$renderLoop.requestRender();
}


//# sourceMappingURL=ik.e8600900.js.map
